import styled, { css } from 'styled-components';
import { progressSuccess, navyOverlay14 } from '../../../themes/colors';
import { getProgressColor } from './progressUtils';

export const ProgressBarFill = styled.div<{
	$progress: number;
	$percent: number;
	$useDynamicColors: boolean;
}>`
	height: 8px;
	background-color: ${navyOverlay14};
	overflow: hidden;
	border-radius: 4px;
	position: relative;
	margin-bottom: 8px;

	&:after {
		content: '';
		width: ${({ $progress }) => `${$progress * 100}%`};
		height: 100%;
		max-width: 100%;
		position: absolute;
		top: 0;
		left: 0;

		background-color: ${({ $useDynamicColors, $percent }) =>
		$useDynamicColors ? getProgressColor($percent) : progressSuccess};

		transition: width 0.35s ease-in-out, background-color 0.25s ease;
	}
`;

export const ProgressBarWrapper = styled.div<{ $inline: boolean }>`
	padding: 0;

	${({ $inline }) =>
		$inline === true &&
		css`
			padding: 0 24px;
		`}
`;

export const ValueWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	width: 100%;
`;

export const Value = styled.p`
	font-size: 14px;
	font-weight: 400;
	font-family: 'Red Hat Display', sans-serif;
	margin: 0;
`;
